import React, { RefObject, useRef } from "react";
import { CSSTransition } from "react-transition-group";

import { easings } from "@apps/viewer/src/ts/config";

/**
 * Specification of the enter duration given in milliseconds.
 */
const ENTER_DURATION = 200;

/**
 * Specification of the exit duration given in milliseconds.
 */
const EXIT_DURATION = 200;

/**
 * Simple css fade transition that'll fade the tooltip in / out when it's being
 * shown / hidden.
 */
// tslint:disable-next-line variable-name no-reserved-keywords
export const FadeSlide: React.FC<{
  in?: boolean;
  children: (ref: RefObject<any>) => React.ReactNode;
}> = (props) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <CSSTransition
      {...props}
      mountOnEnter
      unmountOnExit
      timeout={{
        enter: ENTER_DURATION,
        exit: EXIT_DURATION,
      }}
      classNames="utils__tooltip__fade"
      nodeRef={ref}
    >
      <>
        {props.children(ref)}

        <style jsx global>{`
          /** Apply fade-in */
          .utils__tooltip__fade-enter,
          .utils__tooltip__fade-appear {
            opacity: 0.001;
            transform: translateY(5px);
          }

          .utils__tooltip__fade-enter-active,
          .utils__tooltip__fade-appear-active {
            opacity: 1;
            transform: translateY(0);
            transition: opacity ${ENTER_DURATION}ms linear,
              transform ${ENTER_DURATION}ms ${easings.inOutQuad};
          }

          /** Apply fade-out */
          .utils__tooltip__fade-exit {
            pointer-events: none;
            opacity: 1;
            transform: translateY(0);
          }

          .utils__tooltip__fade-exit-active {
            opacity: 0.001;
            transform: translateY(-5px);
            transition: opacity ${EXIT_DURATION}ms linear,
              transform ${EXIT_DURATION}ms ${easings.inOutQuad};
          }

          .utils__tooltip__fade-exit-done {
            opacity: 0;
          }
        `}</style>
      </>
    </CSSTransition>
  );
};
